import { IRapportInfo } from '../../../../../Types/RapportInfoType';
// import { rapportInfos } from '../RapportInfo';

const MURapportMeny: IRapportInfo[] = [];

export default MURapportMeny;
